function initUpsellSlider() {
  const upsellSliderEl = document.querySelector(".upsell-swiper");
  if (!upsellSliderEl) return;

  // Prevent multiple initializations
  if (upsellSliderEl.classList.contains("swiper-initialized")) return;

  console.log("Initializing Upsell Swiper...");

  new Swiper(".upsell-swiper", {
    slidesPerView: 2,
    spaceBetween: 10,
    navigation: {
      nextEl: ".upsell-next-btn",
      prevEl: ".upsell-prev-btn",
    },
    breakpoints: {
      768: {
        slidesPerView: 1.5,
      },
    },
  });
}

// Listen for DOM changes (cart drawer being inserted/updated)
const observer = new MutationObserver(() => {
  initUpsellSlider();
});

observer.observe(document.body, { childList: true, subtree: true });

// Also try once on load in case drawer is already visible
document.addEventListener("DOMContentLoaded", initUpsellSlider);

// -------------------- ADD TO CART --------------------
document.addEventListener("click", async (e) => {
  const btn = e.target.closest(".upsell-add");
  if (!btn) return;

  e.preventDefault();
  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  btn.disabled = true;
  btn.textContent = "Adding...";

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
      }),
    });

    const data = await response.json();
    console.log("Added to cart:", data);

    // Optional: trigger Shopify's built-in cart drawer refresh
    if (window.Shopify && Shopify.theme && Shopify.theme.cart) {
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    }

    // Or manually re-open drawer if your theme supports it
    const drawerToggle = document.querySelector("[data-cart-toggle]");
    if (drawerToggle) drawerToggle.click();

    btn.textContent = "Added ✓";
  } catch (err) {
    console.error("Add to cart failed", err);
    btn.textContent = "Error";
  }

  setTimeout(() => {
    btn.textContent = "Add to Cart";
    btn.disabled = false;
  }, 2000);

  window.location.reload();
});
